import { GlSkeletonLoader, GlAlert } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../alert.js?vue3';
import axios from '../../lib/utils/axios_utils.js?vue3';
import { handleLocationHash } from '~/lib/utils/common_utils';
import { renderGFM } from '../../behaviors/markdown/render_gfm.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { __ } from '~/locale';
import { initVueApp } from '../../lib/utils/vue3compat/init_vue_app.js?vue3';
import { getHeadingsFromDOM } from '~/content_editor/services/table_of_contents_utils';
import { scaleTablesForPrint, resetScrollForPrint } from '../utils/print_table_scale';
import TableOfContents from './table_of_contents.vue?vue3';
export default {
    name: 'WikiContent',
    components: {
        GlSkeletonLoader,
        GlAlert
    },
    directives: {
        SafeHtml
    },
    inject: [
        'contentApi'
    ],
    data () {
        return {
            content: '',
            isLoadingContent: false,
            loadingContentFailed: false
        };
    },
    mounted () {
        this.loadWikiContent();
        window.addEventListener('beforeprint', this.onBeforePrint);
        window.addEventListener('afterprint', this.onAfterPrint);
    },
    beforeDestroy () {
        window.removeEventListener('beforeprint', this.onBeforePrint);
        window.removeEventListener('afterprint', this.onAfterPrint);
    },
    methods: {
        onBeforePrint () {
            if (!this.$refs.content) return;
            scaleTablesForPrint(this.$refs.content);
            this.restoreTableScroll = resetScrollForPrint(this.$refs.content);
        },
        onAfterPrint () {
            if (!this.restoreTableScroll) return;
            this.restoreTableScroll();
            this.restoreTableScroll = null;
        },
        async renderHeadingsInSidebar () {
            const headings = getHeadingsFromDOM(this.$refs.content);
            if (!headings.length) return;
            const tocContainer = document.querySelector('.js-wiki-toc');
            if (!tocContainer) return;
            const el = document.createElement('div');
            tocContainer.replaceChildren(el);
            initVueApp({
                el,
                name: 'WikiTableOfContentsRoot',
                component: TableOfContents,
                props: {
                    headings
                }
            });
        },
        async loadWikiContent () {
            this.loadingContentFailed = false;
            this.isLoadingContent = true;
            try {
                const { data: { content } } = await axios.get(this.contentApi, {
                    params: {
                        render_html: true
                    }
                });
                this.content = content;
                this.isLoadingContent = false;
                this.$nextTick().then(()=>{
                    renderGFM(this.$refs.content);
                    handleLocationHash();
                    this.renderHeadingsInSidebar();
                }).catch(()=>{
                    createAlert({
                        message: this.$options.i18n.renderingContentFailed
                    });
                });
            } catch (e) {
                this.isLoadingContent = false;
                this.loadingContentFailed = true;
            }
        }
    },
    i18n: {
        loadingContentFailed: __('The content for this wiki page failed to load. To fix this error, reload the page.'),
        retryLoadingContent: __('Retry'),
        renderingContentFailed: __('The content for this wiki page failed to render.')
    }
};
